module.exports = __webpack_public_path__ + "static/media/CRY.5b0ba86d.png";